import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { playAudio } from "../../utils/btnAudio";
import { CButton, CookEInput } from "../CommonComponents";

export default function EditListModal({
  isOpen,
  openModal,
  closeModal,
  submitList,
  newList,
  handleChange,
  close,
  error,
}) {
  return (
    <>
      {/* <div className="fixed inset-0 flex items-center justify-center">
                <button
                    type="button"
                    onClick={openModal}
                    className="rounded-md bg-black bg-opacity-20 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                >
                    Open dialog
                </button>
            </div> */}

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={close}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-xl  font-semibold leading-6 text-gray-900"
                  >
                    Rename List
                  </Dialog.Title>
                  <div className="mt-2">
                    {/* <p className="text-md text-gray-600">
                                            
                                        </p> */}

                    <CookEInput
                      value={newList}
                      type="text"
                      placeholder={"Enter a list name"}
                      onChange={handleChange}
                    />
                    {error && (
                      <p style={{ color: "red", fontSize: "10px" }}>{error}</p>
                    )}
                  </div>

                  <div className="mt-4 flex gap-4">
                    <CButton
                      label={"Close"}
                      variant={"orange"}
                      size={"middle"}
                      className={"w-1/2"}
                      type="button"
                      onClick={() => {
                        close();
                      }}
                    ></CButton>

                    <CButton
                      label={"Rename List"}
                      variant={"red"}
                      size={"middle"}
                      className={"w-1/2"}
                      type="button"
                      onClick={() => {
                        closeModal();
                      }}
                    ></CButton>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
